export var SubscriptionInterval;
(function (SubscriptionInterval) {
    SubscriptionInterval["day"] = "day";
    SubscriptionInterval["week"] = "week";
    SubscriptionInterval["month"] = "month";
    SubscriptionInterval["year"] = "year";
})(SubscriptionInterval || (SubscriptionInterval = {}));
//# sourceMappingURL=SubscriptionInterval.enum.js.map